export default "__VITE_ASSET__701542f9__"